import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import * as CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
declare const Chart: any;
declare const homechart: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  modal: any;
  constructor(private router: Router) { }

  ngOnInit(): void {
    // after API working please remove lines of code below this comment
    //  if(!Cookies.get('tData')){
    //     this.router.navigate(['/login']);
    //   }
    console.log("Hello");
    homechart();
    var Router = this.router;
    if ($(window).width() > 767) {
      $(document).ready(function () {
        $('.dashboard').addClass('active');
        $('.dashboard a').css('color', '#fff');
        $('.dashboard img').attr('src', './assets/image/icon/Dashboard.png');
      });
      $(".header-title p").text('Dashboard');
    }


  }

}
